<page-grid
  [gridConfig]="gridConfig"
  (gridEvent)="applyUpdate()"
  (gridClickColumn)="handleItemClick($event)">
  <ng-template #actionItem let-item="item">
    @if (item?.isAmountMatches && !item.userApproved && !item.dateApproved) {
    <button mat-icon-button (click)="applyRevert(item)"
            matTooltip="{{item?.revert ? 'Undo' : 'Revert'}}" matTooltipPosition="above"
            [disabled]="item?.shouldResolve">
      <mat-icon>
        @if (item?.revert) {
        undo
        } @else {
        redo
        }
      </mat-icon>
    </button>
    }
    @if (item?.isAmountMatches) {
    @if (!item?.userApproved && !item?.dateApproved) {
    <mat-checkbox [checked]="item?.isResolved" [disabled]="!item?.revert" (change)="setResolve(item)"
                  matTooltip="Resolve" matTooltipPosition="below" />
    <mat-slide-toggle [(ngModel)]="item.isEnabled" (change)="handleToggleRecord()">{{item?.isEnabled ? 'ON' : 'OFF'}}</mat-slide-toggle>
    }
    }
  </ng-template>
</page-grid>
